import { EMPTY_OBJECT } from '../../../../constants/common'
import { Skeleton } from '../../../Skeleton'
import {
  ProfileActionsWidgetSkeleton,
  useProfileWidgetsHideContext,
} from '../../../Widget'

import * as styles from './EmailProfileActionsWidgetSkeleton.module.css'

function EmailProfileActionsWidgetSkeleton({ className }) {
  const { isWidgetsHidden = false } =
    useProfileWidgetsHideContext() ?? EMPTY_OBJECT

  return (
    <>
      {isWidgetsHidden ? null : (
        <div className={styles.navigation}>
          <Skeleton className={styles.counter} />
          <Skeleton className={styles.arrow} />
          <Skeleton className={styles.arrow} />
        </div>
      )}
      <ProfileActionsWidgetSkeleton className={className} />
    </>
  )
}

export default EmailProfileActionsWidgetSkeleton
